
import Vue from "vue";
import NavigationBtnToInformation from "@/components/NavigationBtnToInformation.vue";

export default Vue.extend({
  name: "ProductImportGuide",
  components: { NavigationBtnToInformation },
});
